import { render } from "./EmployeeSuppliesPanel.vue?vue&type=template&id=7a2ef688&scoped=true"
import script from "./EmployeeSuppliesPanel.vue?vue&type=script&lang=js"
export * from "./EmployeeSuppliesPanel.vue?vue&type=script&lang=js"

import "./EmployeeSuppliesPanel.vue?vue&type=style&index=0&id=7a2ef688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2ef688"]])

export default __exports__